/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useQuery } from '@office-start/data-fetching';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { getLocStrings } from '../getLocStrings';
/**
 * @param partnerResourceIdentifier (optional for TAOS, required for partners)
 * Name of the JSON containing default english strings under locstrings-service-package/src/strings/
 * ex: "search-me-control-resources" for search-me-control-resources.json.
 * Note: Incase .json has been added, it will be stripped off before usage under getLocStrings.ts
 */
export function useLocStrings(partnerResourceIdentifier) {
    var _a, _b;
    if (partnerResourceIdentifier === void 0) { partnerResourceIdentifier = 'office-start-resources'; }
    var context = useOfficeComponentContext().data;
    var featureGates = useFeatureGates().data;
    var query = [
        'LocStrings',
        partnerResourceIdentifier,
        ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.m365StringLogoGates) === null || _b === void 0 ? void 0 : _b.m365StringLogoEnabled) ||
            false,
    ];
    return useQuery(query, function () {
        return getLocStrings(context.cdnDomain, context.preferredCulture, context.stringsContainerName, partnerResourceIdentifier, featureGates);
    }, {
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: !!context,
    });
}
//# sourceMappingURL=useLocStrings.js.map